import { service as authService } from '@/auth/auth-service'
import { service as authResourceService } from '@/auth/auth-resource-service'
import { service as documentService } from '@/api/document'
import { service as billingPrimaryService } from '@/api/billing-primary'
import { service as profileService } from '@/api/profile'
import { service as globalService } from '@/api/global'
import { service as hyperCommonService } from '@/api/hyper-common'
import {
    /* auth */
    FETCH_AUTH_RESOURCE_REQUEST,
    FETCH_AUTH_RESOURCE_SUCCESS,
    FETCH_AUTH_RESOURCE_FAILED,
    CREATE_MEMBER_AUTH_REQUEST,
    CREATE_MEMBER_AUTH_SUCCESS,
    CREATE_MEMBER_AUTH_FAILED,
    CREATE_MEMBER_AUTH_OTP_REQUEST,
    CREATE_MEMBER_AUTH_OTP_SUCCESS,
    CREATE_MEMBER_AUTH_OTP_FAILED,
    DELETE_MEMBER_AUTH_REQUEST,
    DELETE_MEMBER_AUTH_SUCCESS,
    DELETE_MEMBER_AUTH_FAILED,
    /** profile */
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    CREATE_PRIVACY_DOCUMENT_REQUEST,
    CREATE_PRIVACY_DOCUMENT_SUCCESS,
    CREATE_PRIVACY_DOCUMENT_FAILED,
    /** common */
    FETCH_MONTHS_REQUEST,
    FETCH_MONTHS_SUCCESS,
    FETCH_MONTHS_FAILED,
    /** board */
    FETCH_BOARD_DOCUMENTS_REQUEST,
    FETCH_BOARD_DOCUMENTS_SUCCESS,
    FETCH_BOARD_DOCUMENTS_FAILED,
    FETCH_BOARD_DOCUMENT_REQUEST,
    FETCH_BOARD_DOCUMENT_SUCCESS,
    FETCH_BOARD_DOCUMENT_FAILED,
    /** Megazone Pops */
    CREATE_MEGAZONE_POPS_AUTH_REQUEST,
    CREATE_MEGAZONE_POPS_AUTH_SUCCESS,
    CREATE_MEGAZONE_POPS_AUTH_FAILED,
    /** agreement when first `Megazone Pops` login */
    FETCH_PRIVACY_DOCUMENT_REQUEST,
    FETCH_PRIVACY_DOCUMENT_SUCCESS,
    FETCH_PRIVACY_DOCUMENT_FAILED,
    FETCH_PRIVACY_DOCUMENT_VERSIONS_REQUEST,
    FETCH_PRIVACY_DOCUMENT_VERSIONS_SUCCESS,
    FETCH_PRIVACY_DOCUMENT_VERSIONS,
    /** region */
    FETCH_REGION_REQUEST,
    FETCH_REGION_SUCCESS,
    FETCH_REGION_FAILED,
    /** Tags */
    FETCH_TAGS_REQUEST,
    FETCH_TAGS_SUCCESS,
    FETCH_TAGS_FAILED
} from './mutation-type'

/*
    admin
*/
const createTokenAdminAuth = async ({ commit, state, getters, rootGetters }, { email, adminIdx, userIdx }) => {
    commit(CREATE_MEMBER_AUTH_REQUEST)
    try {
        const { data } = await authService.tokenSigninAdmin({ email, adminIdx, userIdx })
        commit(CREATE_MEMBER_AUTH_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEMBER_AUTH_FAILED, error)
        return Promise.reject(error)
    }
}
/*
    Megazone Pops
*/
const createMegazonePopsAuth = async ({ commit, state, getters, rootGetters }, { code }) => {
    commit(CREATE_MEGAZONE_POPS_AUTH_REQUEST)
    try {
        const { data } = await authService.megazonePopsSignin({ code })
        commit(CREATE_MEGAZONE_POPS_AUTH_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEGAZONE_POPS_AUTH_FAILED, error)
        return Promise.reject(error)
    }
}
/*
    auth
*/
const getAuthResource = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_AUTH_RESOURCE_REQUEST)
    try {
        const { data } = await authResourceService.authResource()
        commit(FETCH_AUTH_RESOURCE_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_AUTH_RESOURCE_FAILED, error)
        return Promise.reject(error)
    }
}
const createTokenAuth = async ({ commit, state, getters, rootGetters }, { email }) => {
    commit(CREATE_MEMBER_AUTH_REQUEST)
    try {
        const { data } = await authService.tokenSignin({ email })
        commit(CREATE_MEMBER_AUTH_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEMBER_AUTH_FAILED, error)
        return Promise.reject(error)
    }
}
const createMemberAuth = async ({ commit, state, getters, rootGetters }, { email, password }) => {
    commit(CREATE_MEMBER_AUTH_REQUEST)
    try {
        const { data } = await authService.memberSignin({ email, password })
        commit(CREATE_MEMBER_AUTH_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEMBER_AUTH_FAILED, error)
        return Promise.reject(error)
    }
}
const createMemberAuthOtp = async ({ commit, state, getters, rootGetters }, { otpCode }) => {
    commit(CREATE_MEMBER_AUTH_OTP_REQUEST)
    try {
        const { data } = await authService.memberSigninOtp({ otpCode })
        commit(CREATE_MEMBER_AUTH_OTP_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEMBER_AUTH_OTP_FAILED, error)
        return Promise.reject(error)
    }
}
const deleteMemberAuth = async ({ commit, state, getters, rootGetters }, { id }) => {
    commit(DELETE_MEMBER_AUTH_REQUEST)
    try {
        const { data } = await authService.memberSignout({ id })
        commit(DELETE_MEMBER_AUTH_SUCCESS, data)
        return data
    } catch (error) {
        commit(DELETE_MEMBER_AUTH_FAILED, error)
        throw error
    }
}
const resetPassword = async ({ commit, state, getters, rootGetters }, { email }) => {
    commit(RESET_PASSWORD_REQUEST)
    try {
        const { data } = await profileService.resetPassword({ email })
        commit(RESET_PASSWORD_SUCCESS, data)
        return data
    } catch (error) {
        commit(RESET_PASSWORD_FAILED, error)
        throw error
    }
}
const signAgreement = async ({ commit, state, getters, rootGetters }, { userIdx, signedTc }) => {
    commit(CREATE_PRIVACY_DOCUMENT_REQUEST)
    try {
        const { data } = await profileService.signAgreement({ userIdx, signedTc })
        commit(CREATE_PRIVACY_DOCUMENT_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_PRIVACY_DOCUMENT_FAILED, error)
        throw error
    }
}
/*
    billing primary
*/
const getMonths = async ({ commit, state, getters, rootGetters }, serviceIdx) => {
    commit(FETCH_MONTHS_REQUEST)
    try {
        const { data } = await billingPrimaryService.months(serviceIdx || rootGetters.requiredService)
        commit(FETCH_MONTHS_SUCCESS, data)
    } catch (error) {
        commit(FETCH_MONTHS_FAILED, error)
        throw error
    }
}

/*
    document
*/

const getBoardDocuments = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_BOARD_DOCUMENTS_REQUEST)
    try {
        const { data } = await documentService.getBoardDocuments()
        commit(FETCH_BOARD_DOCUMENTS_SUCCESS, data)
    } catch (error) {
        commit(FETCH_BOARD_DOCUMENTS_FAILED, error)
        throw error
    }
}

const getBoardDocument = async ({ commit, state, getters, rootGetters }, { timestamp, service }) => {
    commit(FETCH_BOARD_DOCUMENT_REQUEST)
    try {
        const { data } = await documentService.getBoardDocument({ timestamp, service })
        commit(FETCH_BOARD_DOCUMENT_SUCCESS, data)
    } catch (error) {
        commit(FETCH_BOARD_DOCUMENT_FAILED, error)
        throw error
    }
}
const getAgreementDocumentVersions = async ({ commit, state, getters, rootGetters }, { locale }) => {
    commit(FETCH_PRIVACY_DOCUMENT_VERSIONS_REQUEST)
    try {
        const { data } = await hyperCommonService.getAgreementDocumentVersions({ locale })
        commit(FETCH_PRIVACY_DOCUMENT_VERSIONS_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_PRIVACY_DOCUMENT_VERSIONS, error)
        throw error
    }
}

const getAgreementDocumentContent = async ({ commit, state, getters, rootGetters }, { version, locale }) => {
    commit(FETCH_PRIVACY_DOCUMENT_REQUEST)
    try {
        const { data } = await hyperCommonService.getAgreementDocumentContent(version, locale)
        commit(FETCH_PRIVACY_DOCUMENT_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_PRIVACY_DOCUMENT_FAILED, error)
        throw error
    }
}

const getRegions = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_REGION_REQUEST)
    try {
        const { data } = await globalService.getRegions()
        commit(FETCH_REGION_SUCCESS, data)
    } catch (error) {
        commit(FETCH_REGION_FAILED, error)
        throw error
    }
}

const getTagsAll = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_TAGS_REQUEST)
    try {
        const { data } = await billingPrimaryService.getTagsAll(rootGetters.serviceIdx)
        commit(FETCH_TAGS_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_TAGS_FAILED, error)
        throw error
    }
}
const getTagsByGroup = async ({ commit, state, getters, rootGetters }, { groupIdx }) => {
    commit(FETCH_TAGS_REQUEST)
    try {
        const { data } = await billingPrimaryService.getTagsByGroup({ groupIdx }, rootGetters.serviceIdx)
        commit(FETCH_TAGS_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_TAGS_FAILED, error)
        throw error
    }
}
const getTagsByProject = async ({ commit, state, getters, rootGetters }, { projectIdx }) => {
    commit(FETCH_TAGS_REQUEST)
    try {
        const { data } = await billingPrimaryService.getTagsByProject({ projectIdx }, rootGetters.requiredService)
        commit(FETCH_TAGS_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_TAGS_FAILED, error)
        throw error
    }
}

export default {
    /** admin */
    createTokenAdminAuth,
    /** Megazone Pops */
    createMegazonePopsAuth,
    /** auth */
    createTokenAuth,
    createMemberAuth,
    createMemberAuthOtp,
    deleteMemberAuth,
    getAuthResource,
    /** profile */
    resetPassword,
    signAgreement,
    /** common */
    getMonths,
    /** board */
    getBoardDocuments,
    getBoardDocument,
    /** privacy */
    getAgreementDocumentVersions,
    /** getPrivacyDocument */
    getAgreementDocumentContent,
    /** region */
    getRegions,
    /** Tags */
    getTagsAll,
    getTagsByGroup,
    getTagsByProject
}
